import React from "react";

export const rowData = [
  { description: "Misrepresentation of Facts" },
  { description: "Total" },
];
export const rowData2 = [
  { description: "Misrepresentation of Facts" },
  { description: "Driver Implanted" },
  { description: "DocumentManipulation / Non –InsurableInterest" },
  { description: "Claim Withdrawn -Fraud" },
  { description: "Total" },
];
export const rowData3 = [
  { description: "Driver Implant" },
  { description: "2 Vehicle Implant" },
  { description: "Documentary Fraud (Fake DL, Fake Policy etc)" },
  { description: "Misrepresentation of Facts" },
  { description: "Fake Accident" },
  { description: "Total" },
];
export const rowData4 = [
  { description: "Misrepresentation of facts" },
  { description: "Total" },
];
export const rowData5 = [
  { description: "Fake Hospitalization" },
  { description: "Fake medical documents" },
  { description: "Medical bill inflation" },
  { description: "Misrepresentation of facts" },
  { description: "Total" },
];
export const rowData6 = [
  { description: "Premium /Commission siphoning" },
  { description: "Document Manipulation" },
  { description: "Fake Policy" },
  { description: "Others" },
  { description: "Total" },
];
export const rowData7 = [{ description: "Others" }, { description: "Total" }];

export const rowData8 = [
  { description: "Cases reported to Police" },
  { description: "Total" },
];

export const StandardRowDataOne = [
  { id: 1, description: "Motor Theft" },
  { id: 2, description: "Motor Own Damage" },
  { id: 3, description: "Motor Third Party" },
  { id: 4, description: "Property" },
  { id: 5, description: "Accident & Health" },
  { id: 6, description: "Total" },
];

export const StandardRowDataTwo = [{ id: 1, description: "Complaints" }];

export const colDataMPHA = [
  {
    fraudDescription: "Motor Theft Fraud ( Misrepresentation of facts)",
    preventiveMeasures:
      "1. Fraudulent claims repudiated.\n2. Database of such cases updated to Dedupe including that of GI council data of such customers.\n3. Special industry alert projects are conducted to identify such frauds.",
  },
  {
    fraudDescription:
      "Motor Own Damage (Misrepresentation of facts / Document manipulations / Driver Implants )",
    preventiveMeasures:
      "1. Fraudulent claims repudiated.\n2. Database of such cases updated to Dedupe including that of GI council data of such customers.",
  },
  {
    fraudDescription:
      "Motor Third Party (Vehicle implant / Driver implant / Misrepresentation of facts /Substitution of parts / Submission of fake documents &amp; Submission of inflated bills)",
    preventiveMeasures:
      "1. Field investigation carried out to establish the genuineness and quantum of loss.\n2.Special projects based on analytic are conducted.",
  },
  {
    fraudDescription: "Property (Misrepresentation)",
    preventiveMeasures:
      "1. Fraudulent claims repudiated.\n2. Database updated to De-dupe such customers subsequently.\n3. Police actions follow thru.\n4. GI cos. Network to share information on Frauds.",
  },
  {
    fraudDescription:
      "Accident &amp; Health ( Fake hospitalization ,Fake / Manipulated / Inflated Medical bills, Misrepresentation)",
    preventiveMeasures:
      "1. Fraudulent claims repudiated.\n2. Hospitals blacklisted / removed from network of hospitals.\n3. Database of such cases updated to Dedupe including that of GI council data of such customers.",
  },
];
export const colDataComplaint = [
  {
    fraudDescription: (
      <React.Fragment>
        <b>Premium Siphoning :</b>
        <br />
        During the quarter, -- cases of premium siphoning were reported.
        <ul style={{ marginLeft: "3rem" }}>
          <li>Premium collected and policy not issued ()</li>
          <li>Commission Siphoning ()</li>
        </ul>
      </React.Fragment>
    ),
    preventiveMeasures:
      "Disciplinary  action  taken  against  employee  in  -- cases, No action could be taken in -- case due to non   co-operation   of   the   complainant   and   in remaining -- cases disciplinary actions against -- employees  &  --  Associate  employee  is  under progress and in -- cases filing of Police complaint is pending.",
  },
  {
    fraudDescription: (
      <React.Fragment>
        <b>Document Manipulation :</b>
        <br />
        During the quarter, -- cases of Document manipulation were reported.
        <ul style={{ marginLeft: "3rem" }}>
          <li>Manipulation of Policy details ()</li>
        </ul>
      </React.Fragment>
    ),
    preventiveMeasures:
      "Police  complaint  filed  in  --  case  against  one Employee.    in    --    cases    action    against    - employees  and  -  agents  is  under  progress.  No action  could  be  taken  in  -  cases  due  to  non  co-operation of the complainant.",
  },
  {
    fraudDescription: (
      <React.Fragment>
        <b>Fake policy :</b>
        <br />
        During the quarter, -- cases of issuance of fake policies were reported.
      </React.Fragment>
    ),
    preventiveMeasures:
      "Police complaint filed in -- case. In -- cases filing of police complaint/s against Unknown Entities (---)  and  Ex-employee  ()  is  under  progress.  No action could be taken in -- cases due to non –co-operation of the complainant/s.",
  },
  {
    fraudDescription: (
      <React.Fragment>
        <b>Others :</b>
        <br />
        During the quarter, -- cases pertaining to ‘Others’ category of fraud
        were reported.
        <ul style={{ marginLeft: "3rem" }}>
          <li>
            Fraudulent calls promising No Claim Bonus refunds / Port to other GI
            Co. ()
          </li>
          <li>Concealment / Misrepresentation of details (10)</li>
          <li>Conflict of Interest cases ()</li>
        </ul>
      </React.Fragment>
    ),
    preventiveMeasures: `--Police Complaints filed in -- cases of fraudulent calls promising NCB refund, in -- cases Filing of Police Complaints is under progress and in - cases disciplinary Action against - broker & 1 Employee is under progress. In remaining -- cases, no action could be taken since the complainant refused to co-operate. \n --Disciplinary action taken against employee in - case, disciplinary action against - employee & - Agent is under progress in -- cases and in remaining -- cases action could not be taken since the complainant refused to co-operate. \n --Disciplinary    Action    taken    against    associate employees  in  --  case  and  in  remaining  -  case action against employee is under progress.`,
  },
];

export const colDataComplaintOther = [
  {
    fraudDescription: (
      <React.Fragment>
        <ul style={{ marginLeft: "3rem" }}>
          <li>Data theft case ()</li>
        </ul>
      </React.Fragment>
    ),
    preventiveMeasures:
      "Filing  of  police  complaint  against  --  employee  is pending.",
  },
  {
    fraudDescription: (
      <React.Fragment>
        <ul style={{ marginLeft: "3rem" }}>
          <li>Premium received in own bank account ()</li>
        </ul>
      </React.Fragment>
    ),
    preventiveMeasures:
      "Disciplinary action taken against -- employee for receiving premium  payment in own bank account.",
  },
  {
    fraudDescription: (
      <React.Fragment>
        <ul style={{ marginLeft: "3rem" }}>
          <li>Amount Received in own bank account fraudulently ()</li>
        </ul>
      </React.Fragment>
    ),
    preventiveMeasures:
      "Disciplinary actions against -- Employee is under progress.",
  },
];
